import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import api from '../services/api';
import { setSelectedCycle } from 'redux/selectedCycle';
import { setNameProperty } from '../redux/nameProperty';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CeleGif from '../images/gifs/celeiro.gif';
import { userPermissionsDomainAction } from 'redux/userPermissionsDomain/actions';
import CycleCodeService from 'services/CycleCodeService';

export default function HandleSelectedProperty(props) {
  const history = useHistory();
  const [properties, setProperties] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    async function loadData() {
      try {
        const properties_ = await api.get('/properties');
        if (properties_.data.length === 0) {
          history.push('/first-property');
        }
        setProperties(properties_.data);
      } catch (err) {
        console.error(err.response.data.message);
      }
    }
    loadData();
  }, [history, props.openHandleProperty]);

  const handleClose = (e) => {
    props.setOpenHandleProperty(false);
  };

  async function handleChooseProperty(id, name) {
    api
      .get(`/properties/choose/${id}`)
      .then((new_access) => {
        localStorage.setItem('access_token', new_access.data.access_token);
        localStorage.setItem('idProperty', id);
        localStorage.setItem('nameProperty', name);
        if (props.nameProperty !== localStorage.getItem('nameProperty')) {
          dispatch(setSelectedCycle(null));
        }
        dispatch(setNameProperty(name));
        dispatch(
          userPermissionsDomainAction(new_access.data.domain_permissions)
        );
      })
      .catch((error) => {
        console.error(error.response.data.message);
      });

    try {
      const firstCycleCode = await CycleCodeService.getFirstCycleCode();
      dispatch(setSelectedCycle(firstCycleCode));
    } catch (error) {
      console.error(error);
    }

    if (window.location.pathname.match(/\d+/)) history.goBack();
  }

  return (
    <div>
      {properties && (
        <Dialog open={props.openHandleProperty} fullWidth>
          <DialogTitle>Selecione uma Fazenda</DialogTitle>
          <List>
            {properties?.map((fazenda) => (
              <ListItem
                button
                onClick={(e) => {
                  handleChooseProperty(fazenda.id, fazenda.name);
                  handleClose(e);
                }}
                key={fazenda.id}
              >
                <img
                  fontSize="large"
                  style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                  src={CeleGif}
                />
                <ListItemText
                  style={{ paddingInline: '0.5rem' }}
                  primary={fazenda.name}
                />
              </ListItem>
            ))}
          </List>
        </Dialog>
      )}
    </div>
  );
}
